(ns common.schema.entities.esign-process.core
  "Common entity-type definition of the eSign process. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the eSign process documents with the calculated fields."
  (:require
   [common.schema.entities.esign-process.schema :as esign-process]
   [common.schema.entities.esign-process.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/esign-process
   :schema                       esign-process/schema
   :name                         {:en "eSign process"}
   :plural                       {:en "eSign processes"}
   :icon                         :fa-pen
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
